<template lang="pug">
nuxt-link.link.gap-2.align-items-center(
  v-if="props.link"
  :to="props.link"
  :aria-label="computedAriaLabel"
  :target="props.target"
  :class="[hoverOverrideClass, $attrs.class]"
)
  span(v-if="props.text") {{ props.text }}
  slot(name="icon")
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type InternalDestinationProps } from './InternalDestination.types';
import { internalDestinationDefaults } from './InternalDestination.defaults';
import useSkinDestinationHoverOverride from '../../../../../composables/useSkinDestinationHoverOverride';

// Define props with default values
const props = withDefaults(
  defineProps<InternalDestinationProps>(),
  internalDestinationDefaults as any,
) as unknown as InternalDestinationProps;

// Import style logic
const { hoverOverrideValue, hoverOverrideClass } =
  useSkinDestinationHoverOverride(props as any);

// Create a computed property for the aria-label
const computedAriaLabel = computed(() => {
  const text = props.text as string | undefined;
  const ariaLabel = props.ariaLabel as string | undefined;

  if (!text && !ariaLabel) {
    return props.link;
  }

  // If text is missing, use ariaLabel; otherwise, use text
  return ariaLabel || text;
});
</script>

<style lang="scss" scoped>
.link {
  &.has-hover-override:hover {
    color: v-bind('hoverOverrideValue') !important;
  }
}
</style>
